import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

// STYLES
import { StepperContainer, Title } from './styles';

const Stepper = ({ name, active, count, current, ...restProps }) => {
  const getSteps = () => {
    const steps = [];

    for (let step = 0; step < count; step++) {
      steps.push(
        <div
          className={clsx(
            'stepper__dot',
            step + 1 === current && 'stepper__dot--active',
            step + 1 < current && 'stepper__dot--complete',
          )}
          key={step}
        />,
      );
    }

    return steps;
  };

  return (
    <StepperContainer
      {...restProps}
      className={clsx('stepper', !!restProps.className && restProps.className)}
    >
      {!!name && !!count && (
        <Title className={active ? '' : 'not-active'} variant="button" color="primary">
          {name}
        </Title>
      )}
      {getSteps()}
    </StepperContainer>
  );
};

Stepper.defaultProps = {
  name: '',
  active: false,
  count: 1,
  current: null,
};

Stepper.propTypes = {
  name: PropTypes.string,
  active: PropTypes.bool,
  count: PropTypes.number,
  current: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([null])]),
};

export default React.memo(Stepper);
